import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import '@elastic/eui/dist/eui_theme_amsterdam_dark.css';

ReactDOM.render(<App />, document.getElementById('root'));
